import { z } from "zod";
import type { EntitlementState } from "./types";

export const offers = [
 { id:"event-pass-30d", name:"행사 패스 30일", priceKrw:3900, billingPeriod:"once", value:["준비표 무제한", "촬영표 인원·장수 무제한", "30일 뒤 자동 종료 · 다시 결제되지 않아요"], checkedAt:"2026-10-17" },
 { id:"pro-yearly", name:"PRO 연간", priceKrw:19900, billingPeriod:"year", value:["행사 패스의 기능 1년", "결산 카드 테마·지난해 결산(결제 연결 뒤)", "갱신 전 안내 · 요금 화면에서 해지"], checkedAt:"2026-10-17" },
] as const;

export const commerceReceiptSchema = z.object({
  eventId: z.string().min(8),
  transactionId: z.string().min(8),
  offerId: z.enum(["event-pass-30d", "pro-yearly"]),
  source: z.enum(["web_pg", "toss_iap"]),
  status: z.enum(["paid", "restored", "grace", "refunded", "revoked", "expired"]),
  effectiveAt: z.string().datetime(),
  expiresAt: z.string().datetime().optional(),
});

export type CommerceReceipt = z.infer<typeof commerceReceiptSchema>;

export function applyCommerceReceipt(current: EntitlementState, raw: CommerceReceipt): EntitlementState {
  const receipt = commerceReceiptSchema.parse(raw);
  if (current.transactionId === receipt.transactionId && new Date(current.updatedAt) > new Date(receipt.effectiveAt)) return current;
  const status = {
    paid: "active",
    restored: "active",
    grace: "grace",
    refunded: "refunded",
    revoked: "revoked",
    expired: "expired",
  }[receipt.status] as EntitlementState["status"];
  return {
    offerId: receipt.offerId,
    status,
    source: receipt.source,
    transactionId: receipt.transactionId,
    expiresAt: receipt.expiresAt,
    updatedAt: receipt.effectiveAt,
  };
}

export function hasProEntitlement(entitlement: EntitlementState, now = new Date()) {
  if (!["active", "grace"].includes(entitlement.status)) return false;
  return !entitlement.expiresAt || new Date(entitlement.expiresAt) > now;
}

export class CommerceUnavailableError extends Error {
  readonly code = "CPH-5032";
  constructor() {
    super("결제 연결 전이라 돈이 움직이지 않았어요. 지금은 모든 기능을 무료로 쓸 수 있어요.");
  }
}

export interface CommercePort {
  checkout(offerId: string): Promise<never>;
  restore(): Promise<never>;
  cancel(): Promise<never>;
}

export const disabledCommercePort: CommercePort = {
  checkout: async () => { throw new CommerceUnavailableError(); },
  restore: async () => { throw new CommerceUnavailableError(); },
  cancel: async () => { throw new CommerceUnavailableError(); },
};

export function reconcileReceipts(receipts: CommerceReceipt[], initial: EntitlementState): EntitlementState {
  return [...receipts]
    .sort((left, right) => left.effectiveAt.localeCompare(right.effectiveAt))
    .reduce(applyCommerceReceipt, initial);
}
